import './ConfirmModal.css';

export default function ConfirmModal({
  isOpen,
  title,
  message,
  type = 'info',
  confirmText = 'Onayla',
  cancelText = 'İptal',
  onConfirm,
  onCancel,
}) {
  if (!isOpen) return null;

  function getIcon() {
    switch (type) {
      case 'warning':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        );
      case 'danger':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        );
      default:
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        );
    }
  }

  function getTitle() {
    if (title) return title;
    switch (type) {
      case 'warning': return 'Uyarı';
      case 'danger':  return 'Dikkat';
      default:        return 'Onay';
    }
  }

  return (
    <div className="confirm-modal-overlay">
      <div className={`confirm-modal confirm-modal-${type}`}>
        <div className={`confirm-modal-icon confirm-icon-${type}`}>
          {getIcon()}
        </div>
        <div className="confirm-modal-content">
          <h3 className="confirm-modal-title">{getTitle()}</h3>
          <p className="confirm-modal-message">{message}</p>
        </div>
        <div className="confirm-modal-actions">
          <button className="confirm-modal-button confirm-button-cancel" onClick={onCancel}>
            {cancelText}
          </button>
          <button className={`confirm-modal-button confirm-button-${type}`} onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
